export const doctor = {
  "alias": "丹小科",
  "social_item_structure": [
    {
      "label": "LINE",
      "name": "LINE官方帳號",
      "url": "https://www.dentco.tw/",
      "line_page_status": 1
    },
    {
      "label": "Instagram",
      "name": "IG衛教分享",
      "url": "https://www.instagram.com/dentco_tw/"
    },
    {
      "label": "Facebook",
      "name": "",
      "url": "https://www.facebook.com/companyfordentist"
    },
    {
      "label": "Tiktok",
      "name": "衛教短影音",
      "url": "https://www.tiktok.com/@dental_little_helper"
    },
    {
      "label": "YouTube",
      "name": "",
      "url": "https://www.youtube.com/@dentco1460"
    },
    {
      "label": "其他連結1",
      "name": "官網",
      "url": "https://www.dentco.tw/"
    },
    {
      "label": "其他連結2",
      "name": "",
      "url": ""
    },
    {
      "label": "其他連結3",
      "name": "",
      "url": ""
    }
  ],
  "hashtag_item_structure": [
    {
      "title": "人工植牙",
      "category": 1,
      "dental_icon_id": 17,
      "description": "評估缺牙狀況，提供單顆到全口植牙治療。"
    },
    {
      "title": "牙周病治療",
      "category": 999,
      "dental_icon_id": 20,
      "description": "處理牙齦紅腫流血、牙周囊袋與口臭問題。"
    },
    {
      "title": "兒童牙科",
      "category": 999,
      "dental_icon_id": 13,
      "description": "看診流程友善，提供乳牙治療與預防性保健。"
    },
    {
      "title": "美白貼片",
      "category": 999,
      "dental_icon_id": 31,
      "description": "針對牙齒色澤不均，打造自然明亮笑容。"
    },
    {
      "title": "顯微根管治療",
      "category": 999,
      "dental_icon_id": 8,
      "description": "提升根管成功率，保留原生牙齒。"
    }
  ],
  "service_area": [
    "新北市",
    "臺北市"
  ],
  "doctor_code": "2f8Dcapm",
  "doctor_name": "丹小科",
  "profile": "https://cdn.dentco.tw/asset/home/defaultDoctorAvatar_square.jpg",
  "banner": "https://i.imgur.com/l6Ij1AT.png",
  "email": "xxx@gmail.com",
  "principle": "致力提供細心、安心的診療體驗，守護每一位患者的笑容。",
  "qualification": "小幫手牙醫診所院長,前丹科智慧牙醫副院長,中華民國植牙學會會員,植牙專科醫師,Dent&Co植牙學會會長",
  "education": [
    {
      "name": "",
      "year": "2000,2006",
      "school": "臺灣大學",
      "partment": "牙醫學系"
    },
    {
      "name": "",
      "year": "2006,2012",
      "school": "臺灣大學",
      "partment": "口腔醫學部（牙科部）"
    }
  ],
  "line_page": "https://lin.ee/RYOoUcr",
  "line_page_btn_text": "",
  "line_page_status": "1",
  "clinics": [
    {
      "clinic_name": "小幫手牙醫診所",
      "doctor_open_date": [
        {
          "up": false,
          "middle": false,
          "down": false
        },
        {
          "up": true,
          "middle": false,
          "down": false
        },
        {
          "up": false,
          "middle": true,
          "down": false
        },
        {
          "up": false,
          "middle": true,
          "down": false
        },
        {
          "up": true,
          "middle": false,
          "down": true
        },
        {
          "up": false,
          "middle": false,
          "down": true
        },
        {
          "up": true,
          "middle": true,
          "down": false
        }
      ],
      "visit_clinic_note": "只接受線上預約",
      "color": "#009EEB",
      "schedule": {
        "morning": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        "afternoon": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        "evening": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ]
      }
    },
    {
      "clinic_name": "丹科智慧牙醫診所",
      "doctor_open_date": [
        {
          "up": false,
          "middle": false,
          "down": false
        },
        {
          "up": false,
          "middle": true,
          "down": true
        },
        {
          "up": false,
          "middle": false,
          "down": true
        },
        {
          "up": false,
          "middle": false,
          "down": true
        },
        {
          "up": false,
          "middle": false,
          "down": false
        },
        {
          "up": false,
          "middle": false,
          "down": false
        },
        {
          "up": false,
          "middle": false,
          "down": false
        }
      ],
      "visit_clinic_note": "臨時約診請撥打診所電話",
      "color": "#fc9800",
      "schedule": {
        "morning": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        "afternoon": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        "evening": [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ]
      }
    }
  ]
}

export const doctorHealthPost = [
  {
    "id": 1,
    "doctor_code": "2f8Dcapm",
    "title": "大牙縫的補救方法",
    "content": "常見的大牙縫改善方式包含：牙齒矯正可重新排列齒列、改善發音與咬合，陶瓷貼片能快速修飾牙齒大小與色澤，全瓷冠適合修補斷裂或缺角牙齒，若因牙齦退縮產生縫隙，則可透過牙肉移植填補缺損、恢復美觀。",
    "gallery": [
      "https://cdn.dentco.tw/doctor/images/galleries/68832fa6d2282.png"
    ],
    "created_at": "2025-07-25 07:17:58",
    "category_id": [
      1
    ]
  },
  {
    "id": 2,
    "doctor_code": "2f8Dcapm",
    "title": "牙齦長出膿包是發炎還是感染？",
    "content": "牙齦腫包可能是牙周膿包或根尖發炎引起。",
    "gallery": [
      "https://cdn.dentco.tw/doctor/images/galleries/68832ff4bab9c.png"
    ],
    "created_at": "2025-07-25 07:19:16",
    "category_id": [
      1
    ]
  },
  {
    "id": 3,
    "doctor_code": "2f8Dcapm",
    "title": "矯正術前術後案例",
    "content": "",
    "gallery": [
      "https://cdn.dentco.tw/doctor/images/galleries/6883301b54d32.png"
    ],
    "created_at": "22025-07-25 07:19:55",
    "category_id": [
      1
    ]
  }
]
export const doctorHealthCategories = [
  {
    "id": 1,
    "name": "矯正治療",
    "sort": 1
  },
  {
    "id": 2,
    "name": "口腔衛教",
    "sort": 2
  },
  {
    "id": 3,
    "name": "美齒保健",
    "sort": 3
  },
  {
    "id": 4,
    "name": "牙周病衛教",
    "sort": 4
  },
  {
    "id": 5,
    "name": "植牙衛教",
    "sort": 5
  }
]

export const doctorHealthVideos = {
  "short": [
    {
      "platform": "youtube-shorts",
      "url": "https://www.youtube.com/shorts/hbz41pd88_g"
    },
    {
      "platform": "youtube-shorts",
      "url": "https://www.youtube.com/shorts/3NOXFIeOw6k"
    },
    {
      "platform": "youtube-shorts",
      "url": "https://www.youtube.com/shorts/JtZhq0orZNU"
    }
  ],
  "regular": [
    {
      "id": 35,
      "platform": "youtube",
      "type": "regular",
      "url": "https://www.youtube.com/watch?v=CEbF0cWr5es",
      "sort": 1
    }
  ]
}

export const clinicList = [
  {
    "id": "4532",
    "clinic_code": "0000000001",
    "clinic_name": "小幫手牙醫診所",
    "clinic_color": 5,
    "color_code": "#009EEB",
    "city": "4532"
  },
  {
    "id": "8512",
    "clinic_code": "0000000002",
    "clinic_name": "丹科智慧牙醫診所",
    "clinic_color": 1,
    "color_code": "#fc9800",
    "city": "8512"
  }
]

export const permissionInfo = {
  "name": "丹小科",
  "code": "Dentco",
  "plan": 4,
  "doctor_code": "2f8Dcapm",
  "clinics": [
    {
      "name": "Dent&Co基礎診所",
      "code": "0000000001",
      "plan": 1,
      "agency_code": "0000000001",
      "permission_name": [
        "line_appointment",
        "guide_to_line"
      ],
      "permissions": [
        {
          "id": 1,
          "plan_id": 1,
          "permission_id": 1,
          "permission": {
            "id": 1,
            "name": "可以使用line預約",
            "code_name": "line_appointment",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        },
        {
          "id": 69,
          "plan_id": 1,
          "permission_id": 4,
          "permission": {
            "id": 4,
            "name": "可以使用私訊預約",
            "code_name": "guide_to_line",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        }
      ],
      "addon_purchases": []
    },
    {
      "name": "Dent&Co Clinic",
      "code": "0000000088",
      "plan": 2,
      "agency_code": "0000000088",
      "permission_name": [
        "line_appointment",
        "web_appointment",
        "adv_page",
        "guide_to_line",
        "adv_review_with_ai",
        "free_google_map_appointment"
      ],
      "permissions": [
        {
          "id": 2,
          "plan_id": 2,
          "permission_id": 1,
          "permission": {
            "id": 1,
            "name": "可以使用line預約",
            "code_name": "line_appointment",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        },
        {
          "id": 3,
          "plan_id": 2,
          "permission_id": 2,
          "permission": {
            "id": 2,
            "name": "可以使用跨渠道預約",
            "code_name": "web_appointment",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        },
        {
          "id": 4,
          "plan_id": 2,
          "permission_id": 3,
          "permission": {
            "id": 3,
            "name": "官網顯示進階頁面",
            "code_name": "adv_page",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        },
        {
          "id": 26,
          "plan_id": 2,
          "permission_id": 4,
          "permission": {
            "id": 4,
            "name": "可以使用私訊預約",
            "code_name": "guide_to_line",
            "type": null,
            "created_at": "2025-04-16 06:29:56",
            "updated_at": null
          }
        }
      ],
      "addon_purchases": [
        {
          "id": 957,
          "entity_type": 1,
          "entity_code": "0000000088",
          "addon_id": 2,
          "addon_name": "評價AI回覆",
          "created_at": "2025-07-16 03:17:18",
          "updated_at": null,
          "deleted_at": null,
          "addon": {
            "id": 2,
            "name": "評價AI回覆",
            "code_name": "adv_review_with_ai",
            "addon_type": 1,
            "description": null,
            "original_price": "1000.00",
            "unit": "月",
            "sort": 3,
            "created_at": "2024-11-11 07:34:16",
            "updated_at": "2025-07-15 17:28:40",
            "deleted_at": null,
            "permissions": [
              {
                "id": 2,
                "addon_id": 2,
                "permission_id": 6,
                "created_at": "2024-11-11 07:36:25",
                "updated_at": null,
                "deleted_at": null,
                "permission": {
                  "id": 6,
                  "name": "可以使用進階評價AI賦能\t",
                  "code_name": "adv_review_with_ai",
                  "type": null,
                  "created_at": "2025-04-16 06:29:56",
                  "updated_at": null
                }
              }
            ]
          }
        },
        {
          "id": 958,
          "entity_type": 1,
          "entity_code": "0000000088",
          "addon_id": 25,
          "addon_name": "免費版Google技術合作預約",
          "created_at": "2025-07-16 03:17:18",
          "updated_at": null,
          "deleted_at": null,
          "addon": {
            "id": 25,
            "name": "免費版Google技術合作預約",
            "code_name": "free_google_map_appointment",
            "addon_type": 1,
            "description": "不用錢做慈善",
            "original_price": "0.00",
            "unit": "數量",
            "sort": 2,
            "created_at": "2025-07-15 17:28:31",
            "updated_at": "2025-07-15 17:28:40",
            "deleted_at": null,
            "permissions": [
              {
                "id": 3,
                "addon_id": 25,
                "permission_id": 7,
                "created_at": "2025-07-15 09:31:12",
                "updated_at": null,
                "deleted_at": null,
                "permission": {
                  "id": 7,
                  "name": "可以使用Google Map預約(僅登記)",
                  "code_name": "free_google_map_appointment",
                  "type": null,
                  "created_at": "2025-07-15 09:30:12",
                  "updated_at": "2025-07-15 09:30:12"
                }
              }
            ]
          }
        }
      ]
    }
  ],
  "type": "2",
  "permission_name": [
    "line_appointment",
    "web_appointment",
    "adv_page",
    "guide_to_line",
    "adv_review_with_ai"
  ],
  "permissions": [
    {
      "id": 6,
      "plan_id": 4,
      "permission_id": 1,
      "permission": {
        "id": 1,
        "name": "可以使用line預約",
        "code_name": "line_appointment",
        "type": null,
        "created_at": "2025-04-16 06:29:56",
        "updated_at": null
      }
    },
    {
      "id": 7,
      "plan_id": 4,
      "permission_id": 2,
      "permission": {
        "id": 2,
        "name": "可以使用跨渠道預約",
        "code_name": "web_appointment",
        "type": null,
        "created_at": "2025-04-16 06:29:56",
        "updated_at": null
      }
    },
    {
      "id": 8,
      "plan_id": 4,
      "permission_id": 3,
      "permission": {
        "id": 3,
        "name": "官網顯示進階頁面",
        "code_name": "adv_page",
        "type": null,
        "created_at": "2025-04-16 06:29:56",
        "updated_at": null
      }
    },
    {
      "id": 27,
      "plan_id": 4,
      "permission_id": 4,
      "permission": {
        "id": 4,
        "name": "可以使用私訊預約",
        "code_name": "guide_to_line",
        "type": null,
        "created_at": "2025-04-16 06:29:56",
        "updated_at": null
      }
    }
  ],
  "addon_purchases": [
    {
      "id": 561,
      "entity_type": 2,
      "entity_code": "2f8Dcapm",
      "addon_id": 2,
      "addon_name": "可以使用進階評價AI賦能",
      "created_at": "2024-12-10 03:01:57",
      "updated_at": null,
      "deleted_at": null,
      "addon": {
        "id": 2,
        "name": "評價AI回覆",
        "code_name": "adv_review_with_ai",
        "addon_type": 1,
        "description": null,
        "original_price": "1000.00",
        "unit": "月",
        "sort": 3,
        "created_at": "2024-11-11 07:34:16",
        "updated_at": "2025-07-15 17:28:40",
        "deleted_at": null,
        "permissions": [
          {
            "id": 2,
            "addon_id": 2,
            "permission_id": 6,
            "created_at": "2024-11-11 07:36:25",
            "updated_at": null,
            "deleted_at": null,
            "permission": {
              "id": 6,
              "name": "可以使用進階評價AI賦能\t",
              "code_name": "adv_review_with_ai",
              "type": null,
              "created_at": "2025-04-16 06:29:56",
              "updated_at": null
            }
          }
        ]
      }
    }
  ]
}

export const reviewOverview = {
  "total": {
    "count": 99,
    "message": 2,
    "negative": 0,
    "star": 4.9
  },
  "recommend": {
    "醫師專業/治療後效果佳": 5,
    "技術熟練/過程迅速": 5,
    "詳細解說/有耐心": 5,
    "看診準時": 4,
    "價格合理": 5
  },
  "negative": {
    "態度不佳(助理)": 3,
  },
  "star": {
    "看診醫師": 5,
    "跟診助理": 3,
    "櫃檯人員": 5,
    "環境設備": 5,
    "諮詢人員": 5
  }
}

export const reviewList = [
  {
    "review_update_time": "2025-06-16 10:12:22",
    "response_update_time": "2025-06-16 10:13:27",
    "id": "1063227",
    "is_read": "1",
    "ai_generate_response": "非常抱歉讓您有不滿意的經驗！我們會立即檢討看診流程和人員服務，特別是針對醫生和助理的部分，強化培訓與溝通技巧🙏。我們致力於為每位患者提供更好、更舒適的就診體驗，希望能在未來贏回您的信任！有任何建議或需要更進一步的協助，歡迎隨時聯繫我們，感謝您的寶貴回饋。若有問題歡迎來電，期待未來能讓您感受到我們的進步和改善。",
    "ai_generating": "0",
    "name": "王小明",
    "clinic_name": "小幫手牙醫診所",
    "doctor_name": "丹小科",
    "message": "",
    "response": "您好～\n\n非常抱歉這次的看診經驗未能達到您的期望。我們對於看診醫師和跟診助理的服務感到遺憾，我們將立即進行內部檢討與改善，並加強相關訓練，以確保未來能提供更好的服務。希望您能給我們再次為您服務的機會，讓您看到我們的改變與成長。\n\n若有其他意見或建議，也歡迎隨時聯繫我們。感謝您的回饋！若有問題歡迎來電。期待日後看診能帶給您舒適與安心！🙏",
    "created_time": "2025-06-16 (一) 18:12",
    "updated_time": "2025-06-19 15:52",
    "star": {
      "看診醫師": 1,
      "跟診助理": 1,
      "櫃檯人員": 3,
      "環境設備": 5,
      "諮詢人員": 5
    },
    "recommend": [
      "看診準時"
    ],
    "negative": [
      "跟診助理：態度不佳"
    ],
    "treatment": [
      "假牙"
    ],
    "photo": []
  },
  {
    "review_update_time": "2025-06-09 06:24:50",
    "response_update_time": "2025-06-09 06:25:42",
    "id": "1059531",
    "is_read": "1",
    "ai_generate_response": "您好～ 對於您在看診過程中遇到的問題，我們深感抱歉😥。感謝您提供的寶貴意見，這讓我們有機會檢討並改善服務。 我們正在加強櫃檯與諮詢人員的溝通與訓練，致力提升整體看診體驗，希望未來能讓您有更愉快的診療經驗。若有任何疑問或建議，隨時歡迎來電：0277448587。謝謝您的包容與理解！",
    "ai_generating": "0",
    "name": "陳育珊",
    "clinic_name": "Dent&Co Clinic",
    "doctor_name": "丹小科",
    "message": "第一次來就覺得醫師很專業，也很有耐心解釋，整體流程也很順。環境乾淨舒適，值得推薦！",
    "response": "您好～感謝您寶貴的回饋，醫師與團隊都非常開心收到您的肯定🥰！我們會繼續保持高品質的診療與貼心的服務，期待未來再次為您服務～祝您一切順心健康！",
    "created_time": "2025-06-09 (一) 14:24",
    "updated_time": "2025-06-09 14:25",
    "star": {
      "看診醫師": 5,
      "跟診助理": 5,
      "櫃檯人員": 5,
      "環境設備": 5,
      "諮詢人員": 5
    },
    "recommend": [
      "價格合理"
    ],
    "negative": [],
    "treatment": [
      "假牙"
    ],
    "photo": []
  }
]

export const generateFakeReservations = (count, startDateStr, endDateStr) => {
  const startDate = new Date(startDateStr)
  const endDate = new Date(endDateStr)
  endDate.setHours(23, 59, 59, 999)

  const fakePatients = [
    { name: "林冠廷", sex: "0", birthday: "1990/04/15", phone: "0912-345-678" },
    { name: "陳宛蓉", sex: "1", birthday: "1988/11/22", phone: "0987-654-321" },
    { name: "張書豪", sex: "0", birthday: "1995/07/08", phone: "0911-112-222" },
    { name: "吳怡萱", sex: "1", birthday: "2000/01/30", phone: "0922-334-444" },
    { name: "黃子傑", sex: "0", birthday: "1985/09/02", phone: "0944-445-555" },
    { name: "蔡雅筑", sex: "1", birthday: "1992/03/17", phone: "0955-556-666" }
  ]

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  function randomChoice(arr) {
    return arr[Math.floor(Math.random() * arr.length)]
  }

  const results = []
  for (let i = 0; i < count; i++) {
    const patient = randomChoice(fakePatients)

    const randomTimestamp = randomInt(startDate.getTime(), endDate.getTime())
    const start = new Date(randomTimestamp)
    start.setMinutes(start.getMinutes() - (start.getMinutes() % 30))
    start.setSeconds(0)
    start.setMilliseconds(0)

    const end = new Date(start.getTime() + 30 * 60 * 1000)
    const birthdayTs = Math.floor(new Date(patient.birthday).getTime() / 1000)

    results.push({
      reserve_no: `${randomInt(10000000, 99999999)}`,
      start_time: `${Math.floor(start.getTime() / 1000)}`,
      end_time: `${Math.floor(end.getTime() / 1000)}`,
      attend_status: randomChoice(['0', '1', '4']),
      note: "",
      remind_cash: "0",
      remind_others: "",
      tel: "(02)89115813",
      bind_status: "1",
      address: "",
      county: "",
      sex: patient.sex,
      name: patient.name,
      phone: patient.phone,
      birthday: `${birthdayTs}`,
      file_name_photo: "",
      clinic_name: "Dent&Co基礎診所",
      clinic_code: Math.random() > 0.5 ? "0000000001" : "0000000002",
      doctor_name: "沐傾",
      doctor_code: "2f8Dcapm",
      patient_code: `FAKE${randomInt(1000, 9999)}`,
      text_color: "",
      is_block: "0",
      reserve_tag: [],
      start: start.getTime(),
      end: end.getTime(),
      timed: true
    })
  }

  return results
}